/**
 * @generated SignedSource<<40aa72ed85e3e50fc1a0fe08722f58e8>>
 * @relayHash 60019fa0669d2577e66db7174eca690f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 985815c6878b5a76357e62468de040fe8b13d5af56eabc395c16c1fe98c89025

import type { ConcreteRequest, Query } from 'relay-runtime';
export type DeploymentState = "CANCELLED" | "FAILED" | "IN_PROGRESS" | "PENDING" | "ROLLED_BACK" | "SUCCESSFUL" | "UNKNOWN" | "%future added value";
export type DevOpsEnvironmentCategory = "DEVELOPMENT" | "PRODUCTION" | "STAGING" | "TESTING" | "UNMAPPED" | "%future added value";
export type GraphStoreIssueAssociatedDeploymentDeploymentState = "CANCELLED" | "FAILED" | "IN_PROGRESS" | "NOT_SET" | "PENDING" | "ROLLED_BACK" | "SUCCESSFUL" | "UNKNOWN" | "%future added value";
export type GraphStoreIssueAssociatedDeploymentEnvironmentType = "DEVELOPMENT" | "NOT_SET" | "PRODUCTION" | "STAGING" | "TESTING" | "UNMAPPED" | "%future added value";
export type GraphStoreIssueAssociatedDeploymentFilterInput = {
  and?: ReadonlyArray<GraphStoreIssueAssociatedDeploymentConditionalFilterInput | null | undefined> | null | undefined;
  or?: ReadonlyArray<GraphStoreIssueAssociatedDeploymentConditionalFilterInput | null | undefined> | null | undefined;
};
export type GraphStoreIssueAssociatedDeploymentConditionalFilterInput = {
  createdAt?: GraphStoreDateFilterInput | null | undefined;
  fromAti?: GraphStoreAtiFilterInput | null | undefined;
  lastModified?: GraphStoreDateFilterInput | null | undefined;
  toAti?: GraphStoreAtiFilterInput | null | undefined;
  to_author?: GraphStoreIssueAssociatedDeploymentAuthorFilterInput | null | undefined;
  to_environmentType?: GraphStoreIssueAssociatedDeploymentEnvironmentTypeFilterInput | null | undefined;
  to_state?: GraphStoreIssueAssociatedDeploymentDeploymentStateFilterInput | null | undefined;
};
export type GraphStoreDateFilterInput = {
  after?: AGG$DateTime | null | undefined;
  before?: AGG$DateTime | null | undefined;
};
export type GraphStoreAtiFilterInput = {
  is?: ReadonlyArray<string> | null | undefined;
  isNot?: ReadonlyArray<string> | null | undefined;
};
export type GraphStoreIssueAssociatedDeploymentAuthorFilterInput = {
  and?: ReadonlyArray<GraphStoreIssueAssociatedDeploymentAuthorFilterInput | null | undefined> | null | undefined;
  authorAri?: GraphStoreAriFilterInput | null | undefined;
  or?: ReadonlyArray<GraphStoreIssueAssociatedDeploymentAuthorFilterInput | null | undefined> | null | undefined;
};
export type GraphStoreAriFilterInput = {
  is?: ReadonlyArray<string> | null | undefined;
  isNot?: ReadonlyArray<string> | null | undefined;
};
export type GraphStoreIssueAssociatedDeploymentEnvironmentTypeFilterInput = {
  is?: ReadonlyArray<GraphStoreIssueAssociatedDeploymentEnvironmentType> | null | undefined;
  isNot?: ReadonlyArray<GraphStoreIssueAssociatedDeploymentEnvironmentType> | null | undefined;
};
export type GraphStoreIssueAssociatedDeploymentDeploymentStateFilterInput = {
  is?: ReadonlyArray<GraphStoreIssueAssociatedDeploymentDeploymentState> | null | undefined;
  isNot?: ReadonlyArray<GraphStoreIssueAssociatedDeploymentDeploymentState> | null | undefined;
};
export type mainAGSQuery$variables = {
  after?: string | null | undefined;
  filter?: GraphStoreIssueAssociatedDeploymentFilterInput | null | undefined;
  first: number;
  ids: ReadonlyArray<string>;
};
export type mainAGSQuery$data = {
  readonly graphStore: {
    readonly issueAssociatedDeploymentBatch: {
      readonly nodes: ReadonlyArray<{
        readonly to: {
          readonly __typename: "GraphStoreBatchIssueAssociatedDeploymentEndNode";
          readonly data: {
            readonly deploymentSequenceNumber?: AGG$Long | null | undefined;
            readonly description?: string | null | undefined;
            readonly displayName?: string | null | undefined;
            readonly environment?: {
              readonly category: DevOpsEnvironmentCategory | null | undefined;
              readonly displayName: string | null | undefined;
            } | null | undefined;
            readonly id?: string;
            readonly issueIds?: ReadonlyArray<string> | null | undefined;
            readonly lastUpdated?: AGG$DateTime | null | undefined;
            readonly pipeline?: {
              readonly displayName: string | null | undefined;
              readonly url: string | null | undefined;
            } | null | undefined;
            readonly state?: DeploymentState | null | undefined;
            readonly updateSequenceNumber?: AGG$Long | null | undefined;
            readonly url?: string | null | undefined;
          } | null | undefined;
        };
      } | null | undefined>;
    } | null | undefined;
  } | null | undefined;
};
export type mainAGSQuery = {
  response: mainAGSQuery$data;
  variables: mainAGSQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ids"
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "ids",
    "variableName": "ids"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v8 = {
  "kind": "ScalarField",
  "name": "url"
},
v9 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*: any*/),
    {
      "kind": "ScalarField",
      "name": "issueIds"
    },
    {
      "kind": "ScalarField",
      "name": "deploymentSequenceNumber"
    },
    {
      "kind": "ScalarField",
      "name": "updateSequenceNumber"
    },
    (v7/*: any*/),
    (v8/*: any*/),
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "ScalarField",
      "name": "state"
    },
    {
      "kind": "ScalarField",
      "name": "lastUpdated"
    },
    {
      "concreteType": "DeploymentPipeline",
      "kind": "LinkedField",
      "name": "pipeline",
      "plural": false,
      "selections": [
        (v8/*: any*/),
        (v7/*: any*/)
      ]
    },
    {
      "concreteType": "DevOpsEnvironment",
      "kind": "LinkedField",
      "name": "environment",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "category"
        },
        (v7/*: any*/)
      ]
    }
  ],
  "type": "DeploymentSummary"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "mainAGSQuery",
    "selections": [
      {
        "concreteType": "GraphStore",
        "kind": "LinkedField",
        "name": "graphStore",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "GraphStoreBatchIssueAssociatedDeploymentConnection",
            "kind": "LinkedField",
            "name": "issueAssociatedDeploymentBatch",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreBatchIssueAssociatedDeploymentNode",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "GraphStoreBatchIssueAssociatedDeploymentEndNode",
                    "kind": "LinkedField",
                    "name": "to",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "data",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "mainAGSQuery",
    "selections": [
      {
        "concreteType": "GraphStore",
        "kind": "LinkedField",
        "name": "graphStore",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "GraphStoreBatchIssueAssociatedDeploymentConnection",
            "kind": "LinkedField",
            "name": "issueAssociatedDeploymentBatch",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreBatchIssueAssociatedDeploymentNode",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "GraphStoreBatchIssueAssociatedDeploymentEndNode",
                    "kind": "LinkedField",
                    "name": "to",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "data",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v9/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v6/*: any*/)
                            ],
                            "type": "Node",
                            "abstractKey": "__isNode"
                          }
                        ]
                      },
                      (v6/*: any*/)
                    ]
                  },
                  (v6/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "985815c6878b5a76357e62468de040fe8b13d5af56eabc395c16c1fe98c89025",
    "metadata": {},
    "name": "mainAGSQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "eb58f0abc520577293fef6e52f27e962";

export default node;
